import {Directive} from '@angular/core';

@Directive({
  selector: '[compareCardHeader]'
})
export class CompareCardHeaderDirective {

  constructor() {
  }

}
